export const GET_TIME_LOADING = 'get/time/loading';
export const GET_TIME_ERROR = 'get/time/error';
export const GET_TIME_SUCCESS = 'get/time/success';

export const POST_TIME_LOADING = 'get/time/loading';
export const POST_TIME_ERROR = 'get/time/error';
export const POST_TIME_SUCCESS = 'get/time/success';